import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';

import './styles/reset.css';
import './styles/main.scss';

import { InfoHintsProvider } from './components/context/InfoHintsContext';
import Header from './components/Header/Header';
import MobileHeader from './components/Header/MobileHeader';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Goals from './pages/Goals';
import Settings from './pages/Settings';
import Welcome from './pages/Welcome';
import Events from './pages/Events';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

import RequireAuth from './components/router/RequireAuth';
import GuestOnly from './components/router/GuestOnly';

import { AuthProvider } from './context/AuthContext';
import NotFound from './pages/NotFound';

const WithHeaderLayout = () => (
  <div className='app'>
    <div className='mobile-header-wrapper'>
      <MobileHeader />
    </div>

    <div className='center-wrapper'>
      <div className='left-wrapper'>
        <Header />
      </div>
      <main className='main-content'>
        <Outlet />
      </main>
    </div>
  </div>
);

const WithoutHeaderLayout = () => <Outlet />;

function AppLayout() {
  return (
    <>
      <AuthProvider>
        <ScrollToTop />

        <Routes>
          <Route element={<WithoutHeaderLayout />}>
            <Route path='/' element={<Navigate to='/welcome' replace />} />

            <Route
              path='/welcome'
              element={
                <GuestOnly>
                  <Welcome />
                </GuestOnly>
              }
            />

            <Route path='*' element={<NotFound />} />
          </Route>

          <Route element={<WithHeaderLayout />}>
            <Route
              path='/dashboard'
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />

            <Route
              path='/transactions'
              element={
                <RequireAuth>
                  <Transactions />
                </RequireAuth>
              }
            />

            <Route
              path='/goals'
              element={
                <RequireAuth>
                  <Goals />
                </RequireAuth>
              }
            />

            <Route
              path='/settings'
              element={
                <RequireAuth>
                  <Settings />
                </RequireAuth>
              }
            />

            <Route
              path='/events'
              element={
                <RequireAuth>
                  <Events />
                </RequireAuth>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </>
  );
}

function App() {
  return (
    <InfoHintsProvider>
      <Router>
        <AppLayout />
      </Router>
    </InfoHintsProvider>
  );
}

export default App;
